export default "__VITE_ASSET__tJ7hiSgu__"